import { AuthGuardService } from "./@core/services/auth-guard.service";
import { PermissionGuardService } from "./@core/services/permission-guard.service";
import { CheckCircleComponent } from "./@core/utils/visual.component";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HttpModule } from "@angular/http";
import { NgModule } from "@angular/core";
import { HttpClientModule } from "@angular/common/http";
import { CoreModule } from "./@core/core.module";
import { ThemeModule } from "./@theme/theme.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import {
  NbAlertModule,
  NbCardModule,
  NbCheckboxModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbSpinnerModule,
  NbToastrModule,
  NbWindowModule,
} from "@nebular/theme";
import { ServicesProvider } from "./@shared/services/services";
import { SalesSimpliProvider } from "./@modules/@vendas/services/salesSimpli";
import { DeuProvider } from "./@shared/services/deu.service";
import { DescargaProvider } from "./@modules/@vendas/services/descarga.service";
import { ChequeProvider } from "./@shared/services/cheque.service";
import { EnvioProvider } from "./@modules/@vendas/services/envio.service";
import { LoginProvider } from "./@modules/@login/services/login.service";
import { FolhaProvider } from "./@modules/@vendas/services/folha.service";
import { PremiosProvider } from "./@shared/services/premios.service";
import { RccProvider } from "./@shared/services/rcc.service";
import { CoringaProvider } from "./@shared/services/coringa.service";
import { ComunicadoProvider } from "./@modules/@gestao/services/comunicado.service";
import { FolgaProvider } from "./@modules/@vendas/services/folga.service";
import { SaldosProvider } from "./@modules/@vendas/services/saldos";
import { DespesasProvider } from "./@modules/@vendas/services/despesas.service";
import { ChatService } from "./@shared/services/chat.service";
import { UserRoleProvider } from "./@shared/services/userRole.service";
import { WebsocketService } from "./@shared/services/webSocket.service";
import { UsersProvider } from "./@modules/@login/services/users.service";
import { UtilsProvider } from "./@shared/services/utils.service";
import { SendAppProvider } from "./@modules/@astral/services/send";
import { DateUtilsProvider } from "./@core/utils/date.utils";
import { AstCategoriasProvider } from "./@modules/@astral/services/astCategorias.service";
import { CambioProvider } from "./@modules/@cambio/services/cambio.service";

import { SimpleTimer } from "ng2-simple-timer";
import { DialogTemplateComponent } from "./@modules/@home/components/card-tarefas/templateModal.component";
import { FormsModule } from "@angular/forms";
import { InterceptorModule } from "./@modules/@login/token.module";

import { Ng2SmartTableModule } from "ng2-smart-table";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { DialogTemplate1Component } from "./@modules/@astral/pages/send/send-view/templateModal.component";
import { RuaTemplateComponent } from "./@modules/@cambio/pages/extrato-diario/modal/ruaModal/ruaModal.component";
import { ResultBasicrovider } from "./@modules/@vendas/pages/lancamentos/resultados-basic/result-basic.service";
import { AuthService } from "./@core/services/auth.service";
import { JwtHelperService, JWT_OPTIONS } from "@auth0/angular-jwt";
import { FormatUtilsProvider } from "./@core/utils/format.utils";
import { BnNgIdleService } from "bn-ng-idle";
import { TarefasProvider } from "./@shared/services/tarefas.service";
import { TarefaDialogComponent } from "./@modules/@home/components/modalTarefas/modalTarefas.component";
import { MapaLoteriasMilharService } from "./@shared/services/mapa_milhar.service";
import { MapaLoteriasCentenaService } from "./@shared/services/mapa_centena.service";

@NgModule({
  declarations: [
    AppComponent,
    CheckCircleComponent,
    DialogTemplateComponent,
    DialogTemplate1Component,
    RuaTemplateComponent,
    TarefaDialogComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    FormsModule,
    HttpModule,
    ThemeModule.forRoot(),
    NbCardModule,
    NbSpinnerModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbDialogModule.forRoot(),
    NbAlertModule,
    CoreModule.forRoot(),
    NgxUiLoaderModule,
    InterceptorModule,
    Ng2SmartTableModule,
    NbCheckboxModule,
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogTemplateComponent,
    DialogTemplate1Component,
    RuaTemplateComponent,
  ],
  providers: [
    ServicesProvider,
    SalesSimpliProvider,
    DeuProvider,
    DescargaProvider,
    ChequeProvider,
    EnvioProvider,
    LoginProvider,
    PremiosProvider,
    FolhaProvider,
    RccProvider,
    CoringaProvider,
    ComunicadoProvider,
    TarefasProvider,
    FolgaProvider,
    SaldosProvider,
    DespesasProvider,
    ChatService,
    UserRoleProvider,
    WebsocketService,
    UsersProvider,
    SimpleTimer,
    UtilsProvider,
    MapaLoteriasMilharService,
    MapaLoteriasCentenaService,
    SendAppProvider,
    DateUtilsProvider,
    FormatUtilsProvider,
    ResultBasicrovider,
    AstCategoriasProvider,
    CambioProvider,
    AuthGuardService,
    PermissionGuardService,
    AuthService,
    BnNgIdleService,
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
  ],
})
export class AppModule {}
